import { render, staticRenderFns } from "./newSunuAssur.vue?vue&type=template&id=5c53a3cc&scoped=true"
import script from "./newSunuAssur.vue?vue&type=script&lang=js"
export * from "./newSunuAssur.vue?vue&type=script&lang=js"
import style0 from "./newSunuAssur.vue?vue&type=style&index=0&id=5c53a3cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c53a3cc",
  null
  
)

export default component.exports